import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Header from "../../Components/Header";
import JobInfo from "../../Components/JobDetails/JobInfo";
import Technician from "../../Components/JobDetails/Technician";
import JobFiles from "../../Components/JobDetails/JobFiles";
import JobForms from "../../Components/JobDetails/JobForms";
import JobCancel from "../../Components/JobDetails/JobCancel";
import LineItems from "../../Components/JobDetails/LineItems";
import useGetJobs from "../../Global/Api/Jobs/getJobs.api";
import {clearState} from "../../Store/Slice/scheduleSlice";
import {setJustRescheduled} from "../../Store/Slice/jobsSlice";
import Modal from "../../Components/Schedule/Modal";
import "./index.scss";

export default function JobsDetails() {
  const {title: jobTitle} = useParams();
  const Jobs = useGetJobs({ allList: false });
  const dispatch = useDispatch();
  const [renderAffirmModal, setRenderAffirmModal] = useState(false);
  const {activeJob, justRescheduled} = useSelector((state) => state.rootReducer.jobsSlice);

  const handleModal = () => {
    dispatch(setJustRescheduled(false));
  };

  useEffect(() => {
    if (jobTitle) {
      Jobs.getById(jobTitle);
    }
  }, [jobTitle]);

  useEffect(() => {
    if(activeJob?.can_fill_affirm) {
      handleMakePaymentWithAffirm()
    }
  }, [activeJob])

  const handleMakePaymentWithAffirm = () => {
    dispatch(clearState());
    setRenderAffirmModal(true);
  }

  return (
    <>
      {justRescheduled ? <Modal handleModal={handleModal} desc={false} text="Job has been Rescheduled!"/> : null}
      <Header title={"Job details"} showFull={true} />
      <div className="details">
        <div className={"details__top"}>
          <div className="details__top-left">
            <JobInfo title={jobTitle} />
          </div>
          <div className="details__top-right">
            <Technician
              renderAffirmModal={renderAffirmModal}
              setRenderAffirmModal={setRenderAffirmModal}
              handleMakePaymentWithAffirm={handleMakePaymentWithAffirm}
            />
          </div>
        </div>
        <div className="details__lineItems">
          <LineItems />
        </div>
        <div className="details__bottom">
          <div className="details__bottom-left">
            <JobFiles />
          </div>
          <div className="details__bottom-right">
            <JobForms />
          </div>
        </div>
        <div className="details__canceled">
          <JobCancel />
        </div>
      </div>
    </>
  );
}
